module.exports = __webpack_public_path__ + "static/media/collapse.eafa5291.svg";